import { SelectBox } from 'macaron-frontend-ui'
import { useCallback } from 'react'
import type { HourMinute } from '~/lib/graphql/scalars'
import { useSendClickEvent } from '~/navigation'
import {
  useChangeTime,
  useTimeOptions,
  useTimesQueryStatus,
  useVisitTime,
} from '~/stores/calendar/state'
import { SelectBoxLoading } from './SelectBoxLoading'

export function VisitTime() {
  const { isLoading, ...props } = useVisitTimeSelection()
  const status = useTimesQueryStatus()
  if (status === 'pending') {
    return <SelectBoxLoading />
  }
  if (status === 'error') {
    throw new Error('予約可能時間の情報を取得できませんでした。')
  }
  return <SelectBox {...props} width={230} />
}

function useVisitTimeSelection() {
  const selectedTime = useVisitTime()
  const timeOptions = useTimeOptions()
  const changeTime = useChangeTime()
  const sendClickEvent = useSendClickEvent()
  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      sendClickEvent({
        inventoryCalendar: 'visitTime',
        click_event: 'newReservationFlow/inventoryCalendar/visitTime',
      })

      // TODO: SelectBox の実装を見直して、素直に value から値がとれるように
      const time = e.target.value.split(' ')[1] as HourMinute
      changeTime(time)
    },
    [changeTime, sendClickEvent]
  )
  const hasReservableTimes = timeOptions.some((option) => option.reservable)
  if (!hasReservableTimes) {
    return {
      values: [],
      label: '空席がありません',
      onChange: nop,
      disabled: true,
      isLoading: false,
    }
  }

  const values = timeOptions.map(
    (option) => `${createLabel(option.reservable)} ${option.visitTime}`
  )
  const option = timeOptions.find((option) => option.visitTime === selectedTime)
  if (option === undefined) {
    const label = `${createLabel(false)} ${selectedTime}`
    return { values, label, onChange, disabled: false, isLoading: false }
  } else {
    const value = `${createLabel(option.reservable)} ${selectedTime}`
    return { values, value, onChange, disabled: false, isLoading: false }
  }
}

function createLabel(reservable: boolean) {
  return reservable ? '◯' : '×'
}

function nop() {}
